import { render, staticRenderFns } from "./SignupStep4.vue?vue&type=template&id=f4aace2e&scoped=true"
import script from "./SignupStep4.vue?vue&type=script&lang=js"
export * from "./SignupStep4.vue?vue&type=script&lang=js"
import style0 from "./SignupStep4.vue?vue&type=style&index=0&id=f4aace2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4aace2e",
  null
  
)

export default component.exports